import React, { useState, useEffect } from 'react';
import './pages_documentos.css';
import { getDatabase, ref, get } from 'firebase/database';
import DataTable from '../utils/Tabela';
import firebaseApp, { KEY_REF } from '../adm/admin/firebaseConfig';
import TitleSection from '../utils/TittleTheme';

import { Box } from '@mui/material';


export default function LOA() {

	const [newsData, setNewsData] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const databaseInstance = getDatabase(firebaseApp);
				const noticiasRef = ref(databaseInstance, `loa`);
	
				const snapshot = await get(noticiasRef);
				const data = snapshot.val();
	
				if (data) {
					const newsArray = Object.keys(data).map((key) => ({
						id: key,
                        title: data[key].nome,
                        numero: data[key].numero || null,
                        mes: data[key].mes,
                        dia: data[key].dia || null,
                        ano: data[key].ano,
                        href: data[key].href
					}));
					setNewsData(newsArray);
				}
			} catch (error) {
				console.error('Erro ao carregar notícias:', error);
			}
		};
	
		fetchData();
	}, []);
	


	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	  }, []);


	return (

		<Box sx={{ padding: 3, maxWidth: '1200px', mx: 'auto' }}>


		<TitleSection title={'LEI ORÇAMENTARIA ANUAL'} subtitle={'Instrumento que estabelece a previsão de receitas e a autorização de despesas do município para o ano fiscal.'}/>
	
		<DataTable data={newsData} />
	  </Box>

	)
}

